'use strict';

/* jshint ignore:start */
/**
 * This code was generated by
 * \ / _    _  _|   _  _
 *  | (_)\/(_)(_|\/| |(/_  v1.0.0
 *       /       /
 */
/* jshint ignore:end */

var Q = require('q');  /* jshint ignore:line */
var _ = require('lodash');  /* jshint ignore:line */
var util = require('util');  /* jshint ignore:line */
var Page = require('../../../../base/Page');  /* jshint ignore:line */
var SyncListItemList = require('./syncList/syncListItem').SyncListItemList;
var SyncListPermissionList = require(
    './syncList/syncListPermission').SyncListPermissionList;
var deserialize = require(
    '../../../../base/deserialize');  /* jshint ignore:line */
var values = require('../../../../base/values');  /* jshint ignore:line */

var SyncListList;
var SyncListPage;
var SyncListInstance;
var SyncListContext;

/* jshint ignore:start */
/**
 * Initialize the SyncListList
 *
 * @constructor Twilio.Sync.V1.ServiceContext.SyncListList
 *
 * @param {Twilio.Sync.V1} version - Version of the resource
 * @param {string} serviceSid -
 *          The SID of the Sync Service that the resource is associated with
 */
/* jshint ignore:end */
SyncListList = function SyncListList(version, serviceSid) {
  /* jshint ignore:start */
  /**
   * @function syncLists
   * @memberof Twilio.Sync.V1.ServiceContext#
   *
   * @param {string} sid - sid of instance
   *
   * @returns {Twilio.Sync.V1.ServiceContext.SyncListContext}
   */
  /* jshint ignore:end */
  function SyncListListInstance(sid) {
    return SyncListListInstance.get(sid);
  }

  SyncListListInstance._version = version;
  // Path Solution
  SyncListListInstance._solution = {serviceSid: serviceSid};
  SyncListListInstance._uri = `/Services/${serviceSid}/Lists`;
  /* jshint ignore:start */
  /**
   * create a SyncListInstance
   *
   * @function create
   * @memberof Twilio.Sync.V1.ServiceContext.SyncListList#
   *
   * @param {object} [opts] - Options for request
   * @param {string} [opts.uniqueName] -
   *          An application-defined string that uniquely identifies the resource
   * @param {number} [opts.ttl] - Alias for collection_ttl
   * @param {number} [opts.collectionTtl] -
   *          How long, in seconds, before the Sync List expires and is deleted
   * @param {function} [callback] - Callback to handle processed record
   *
   * @returns {Promise} Resolves to processed SyncListInstance
   */
  /* jshint ignore:end */
  SyncListListInstance.create = function create(opts, callback) {
    if (_.isFunction(opts)) {
      callback = opts;
      opts = {};
    }
    opts = opts || {};

    var deferred = Q.defer();
    var data = values.of({
      'UniqueName': _.get(opts, 'uniqueName'),
      'Ttl': _.get(opts, 'ttl'),
      'CollectionTtl': _.get(opts, 'collectionTtl')
    });

    var promise = this._version.create({uri: this._uri, method: 'POST', data: data});

    promise = promise.then(function(payload) {
      deferred.resolve(new SyncListInstance(
        this._version,
        payload,
        this._solution.serviceSid,
        this._solution.sid
      ));
    }.bind(this));

    promise.catch(function(error) {
      deferred.reject(error);
    });

    if (_.isFunction(callback)) {
      deferred.promise.nodeify(callback);
    }

    return deferred.promise;
  };

  /* jshint ignore:start */
  /**
   * Streams SyncListInstance records from the API.
   *
   * This operation lazily loads records as efficiently as possible until the limit
   * is reached.
   *
   * The results are passed into the callback function, so this operation is memory
   * efficient.
   *
   * If a function is passed as the first argument, it will be used as the callback
   * function.
   *
   * @function each
   * @memberof Twilio.Sync.V1.ServiceContext.SyncListList#
   *
   * @param {object} [opts] - Options for request
   * @param {number} [opts.limit] -
   *         Upper limit for the number of records to return.
   *         each() guarantees never to return more than limit.
   *         Default is no limit
   * @param {number} [opts.pageSize] -
   *         Number of records to fetch per request,
   *         when not set will use the default value of 50 records.
   *         If no pageSize is defined but a limit is defined,
   *         each() will attempt to read the limit with the most efficient
   *         page size, i.e. min(limit, 1000)
   * @param {Function} [opts.callback] -
   *         Function to process each record. If this and a positional
   *         callback are passed, this one will be used
   * @param {Function} [opts.done] -
   *          Function to be called upon completion of streaming
   * @param {Function} [callback] - Function to process each record
   */
  /* jshint ignore:end */
  SyncListListInstance.each = function each(opts, callback) {
    if (_.isFunction(opts)) {
      callback = opts;
      opts = {};
    }
    opts = opts || {};
    if (opts.callback) {
      callback = opts.callback;
    }
    if (_.isUndefined(callback)) {
      throw new Error('Callback function must be provided');
    }

    var done = false;
    var currentPage = 1;
    var currentResource = 0;
    var limits = this._version.readLimits({
      limit: opts.limit,
      pageSize: opts.pageSize
    });

    function onComplete(error) {
      done = true;
      if (_.isFunction(opts.done)) {
        opts.done(error);
      }
    }

    function fetchNextPage(fn) {
      var promise = fn();
      if (_.isUndefined(promise)) {
        onComplete();
        return;
      }

      promise.then(function(page) {
        _.each(page.instances, function(instance) {
          if (done || (!_.isUndefined(opts.limit) && currentResource >= opts.limit)) {
            done = true;
            return false;
          }

          currentResource++;
          callback(instance, onComplete);
        });

        if (!done) {
          currentPage++;
          fetchNextPage(_.bind(page.nextPage, page));
        } else {
          onComplete();
        }
      });

      promise.catch(onComplete);
    }

    fetchNextPage(_.bind(this.page, this, _.merge(opts, limits)));
  };

  /* jshint ignore:start */
  /**
   * Lists SyncListInstance records from the API as a list.
   *
   * If a function is passed as the first argument, it will be used as the callback
   * function.
   *
   * @function list
   * @memberof Twilio.Sync.V1.ServiceContext.SyncListList#
   *
   * @param {object} [opts] - Options for request
   * @param {number} [opts.limit] -
   *         Upper limit for the number of records to return.
   *         list() guarantees never to return more than limit.
   *         Default is no limit
   * @param {number} [opts.pageSize] -
   *         Number of records to fetch per request,
   *         when not set will use the default value of 50 records.
   *         If no page_size is defined but a limit is defined,
   *         list() will attempt to read the limit with the most
   *         efficient page size, i.e. min(limit, 1000)
   * @param {function} [callback] - Callback to handle list of records
   *
   * @returns {Promise} Resolves to a list of records
   */
  /* jshint ignore:end */
  SyncListListInstance.list = function list(opts, callback) {
    if (_.isFunction(opts)) {
      callback = opts;
      opts = {};
    }
    opts = opts || {};
    var deferred = Q.defer();
    var allResources = [];
    opts.callback = function(resource, done) {
      allResources.push(resource);

      if (!_.isUndefined(opts.limit) && allResources.length === opts.limit) {
        done();
      }
    };

    opts.done = function(error) {
      if (_.isUndefined(error)) {
        deferred.resolve(allResources);
      } else {
        deferred.reject(error);
      }
    };

    if (_.isFunction(callback)) {
      deferred.promise.nodeify(callback);
    }

    this.each(opts);
    return deferred.promise;
  };

  /* jshint ignore:start */
  /**
   * Retrieve a single page of SyncListInstance records from the API.
   *
   * The request is executed immediately.
   *
   * If a function is passed as the first argument, it will be used as the callback
   * function.
   *
   * @function page
   * @memberof Twilio.Sync.V1.ServiceContext.SyncListList#
   *
   * @param {object} [opts] - Options for request
   * @param {string} [opts.pageToken] - PageToken provided by the API
   * @param {number} [opts.pageNumber] -
   *          Page Number, this value is simply for client state
   * @param {number} [opts.pageSize] - Number of records to return, defaults to 50
   * @param {function} [callback] - Callback to handle list of records
   *
   * @returns {Promise} Resolves to a list of records
   */
  /* jshint ignore:end */
  SyncListListInstance.page = function page(opts, callback) {
    if (_.isFunction(opts)) {
      callback = opts;
      opts = {};
    }
    opts = opts || {};

    var deferred = Q.defer();
    var data = values.of({
      'PageToken': opts.pageToken,
      'Page': opts.pageNumber,
      'PageSize': opts.pageSize
    });

    var promise = this._version.page({uri: this._uri, method: 'GET', params: data});

    promise = promise.then(function(payload) {
      deferred.resolve(new SyncListPage(this._version, payload, this._solution));
    }.bind(this));

    promise.catch(function(error) {
      deferred.reject(error);
    });

    if (_.isFunction(callback)) {
      deferred.promise.nodeify(callback);
    }

    return deferred.promise;
  };

  /* jshint ignore:start */
  /**
   * Retrieve a single target page of SyncListInstance records from the API.
   *
   * The request is executed immediately.
   *
   * If a function is passed as the first argument, it will be used as the callback
   * function.
   *
   * @function getPage
   * @memberof Twilio.Sync.V1.ServiceContext.SyncListList#
   *
   * @param {string} [targetUrl] - API-generated URL for the requested results page
   * @param {function} [callback] - Callback to handle list of records
   *
   * @returns {Promise} Resolves to a list of records
   */
  /* jshint ignore:end */
  SyncListListInstance.getPage = function getPage(targetUrl, callback) {
    var deferred = Q.defer();

    var promise = this._version._domain.twilio.request({method: 'GET', uri: targetUrl});

    promise = promise.then(function(payload) {
      deferred.resolve(new SyncListPage(this._version, payload, this._solution));
    }.bind(this));

    promise.catch(function(error) {
      deferred.reject(error);
    });

    if (_.isFunction(callback)) {
      deferred.promise.nodeify(callback);
    }

    return deferred.promise;
  };

  /* jshint ignore:start */
  /**
   * Constructs a sync_list
   *
   * @function get
   * @memberof Twilio.Sync.V1.ServiceContext.SyncListList#
   *
   * @param {string} sid - The SID of the Sync List resource to fetch
   *
   * @returns {Twilio.Sync.V1.ServiceContext.SyncListContext}
   */
  /* jshint ignore:end */
  SyncListListInstance.get = function get(sid) {
    return new SyncListContext(this._version, this._solution.serviceSid, sid);
  };

  /* jshint ignore:start */
  /**
   * Provide a user-friendly representation
   *
   * @function toJSON
   * @memberof Twilio.Sync.V1.ServiceContext.SyncListList#
   *
   * @returns Object
   */
  /* jshint ignore:end */
  SyncListListInstance.toJSON = function toJSON() {
    return this._solution;
  };

  SyncListListInstance[util.inspect.custom] = function inspect(depth, options) {
    return util.inspect(this.toJSON(), options);
  };

  return SyncListListInstance;
};


/* jshint ignore:start */
/**
 * Initialize the SyncListPage
 *
 * @constructor Twilio.Sync.V1.ServiceContext.SyncListPage
 *
 * @param {V1} version - Version of the resource
 * @param {Response<string>} response - Response from the API
 * @param {SyncListSolution} solution - Path solution
 *
 * @returns SyncListPage
 */
/* jshint ignore:end */
SyncListPage = function SyncListPage(version, response, solution) {
  // Path Solution
  this._solution = solution;

  Page.prototype.constructor.call(this, version, response, this._solution);
};

_.extend(SyncListPage.prototype, Page.prototype);
SyncListPage.prototype.constructor = SyncListPage;

/* jshint ignore:start */
/**
 * Build an instance of SyncListInstance
 *
 * @function getInstance
 * @memberof Twilio.Sync.V1.ServiceContext.SyncListPage#
 *
 * @param {SyncListPayload} payload - Payload response from the API
 *
 * @returns SyncListInstance
 */
/* jshint ignore:end */
SyncListPage.prototype.getInstance = function getInstance(payload) {
  return new SyncListInstance(this._version, payload, this._solution.serviceSid);
};

/* jshint ignore:start */
/**
 * Provide a user-friendly representation
 *
 * @function toJSON
 * @memberof Twilio.Sync.V1.ServiceContext.SyncListPage#
 *
 * @returns Object
 */
/* jshint ignore:end */
SyncListPage.prototype.toJSON = function toJSON() {
  let clone = {};
  _.forOwn(this, function(value, key) {
    if (!_.startsWith(key, '_') && ! _.isFunction(value)) {
      clone[key] = value;
    }
  });
  return clone;
};

SyncListPage.prototype[util.inspect.custom] = function inspect(depth, options) {
  return util.inspect(this.toJSON(), options);
};


/* jshint ignore:start */
/**
 * Initialize the SyncListContext
 *
 * @constructor Twilio.Sync.V1.ServiceContext.SyncListInstance
 *
 * @property {string} sid - The unique string that identifies the resource
 * @property {string} uniqueName -
 *          An application-defined string that uniquely identifies the resource
 * @property {string} accountSid - The SID of the Account that created the resource
 * @property {string} serviceSid -
 *          The SID of the Sync Service that the resource is associated with
 * @property {string} url - The absolute URL of the Sync List resource
 * @property {string} links - The URLs of the Sync List's nested resources
 * @property {string} revision -
 *          The current revision of the Sync List, represented as a string
 * @property {Date} dateExpires -
 *          The ISO 8601 date and time in GMT when the Sync List expires
 * @property {Date} dateCreated -
 *          The ISO 8601 date and time in GMT when the resource was created
 * @property {Date} dateUpdated -
 *          The ISO 8601 date and time in GMT when the resource was last updated
 * @property {string} createdBy - The identity of the Sync List's creator
 *
 * @param {V1} version - Version of the resource
 * @param {SyncListPayload} payload - The instance payload
 * @param {sid} serviceSid -
 *          The SID of the Sync Service that the resource is associated with
 * @param {sid_like} sid - The SID of the Sync List resource to fetch
 */
/* jshint ignore:end */
SyncListInstance = function SyncListInstance(version, payload, serviceSid, sid)
                                              {
  this._version = version;

  // Marshaled Properties
  this.sid = payload.sid; // jshint ignore:line
  this.uniqueName = payload.unique_name; // jshint ignore:line
  this.accountSid = payload.account_sid; // jshint ignore:line
  this.serviceSid = payload.service_sid; // jshint ignore:line
  this.url = payload.url; // jshint ignore:line
  this.links = payload.links; // jshint ignore:line
  this.revision = payload.revision; // jshint ignore:line
  this.dateExpires = deserialize.iso8601DateTime(payload.date_expires); // jshint ignore:line
  this.dateCreated = deserialize.iso8601DateTime(payload.date_created); // jshint ignore:line
  this.dateUpdated = deserialize.iso8601DateTime(payload.date_updated); // jshint ignore:line
  this.createdBy = payload.created_by; // jshint ignore:line

  // Context
  this._context = undefined;
  this._solution = {serviceSid: serviceSid, sid: sid || this.sid, };
};

Object.defineProperty(SyncListInstance.prototype,
  '_proxy', {
    get: function() {
      if (!this._context) {
        this._context = new SyncListContext(this._version, this._solution.serviceSid, this._solution.sid);
      }

      return this._context;
    }
});

/* jshint ignore:start */
/**
 * fetch a SyncListInstance
 *
 * @function fetch
 * @memberof Twilio.Sync.V1.ServiceContext.SyncListInstance#
 *
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed SyncListInstance
 */
/* jshint ignore:end */
SyncListInstance.prototype.fetch = function fetch(callback) {
  return this._proxy.fetch(callback);
};

/* jshint ignore:start */
/**
 * remove a SyncListInstance
 *
 * @function remove
 * @memberof Twilio.Sync.V1.ServiceContext.SyncListInstance#
 *
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed SyncListInstance
 */
/* jshint ignore:end */
SyncListInstance.prototype.remove = function remove(callback) {
  return this._proxy.remove(callback);
};

/* jshint ignore:start */
/**
 * update a SyncListInstance
 *
 * @function update
 * @memberof Twilio.Sync.V1.ServiceContext.SyncListInstance#
 *
 * @param {object} [opts] - Options for request
 * @param {number} [opts.ttl] - An alias for collection_ttl
 * @param {number} [opts.collectionTtl] -
 *          How long, in seconds, before the Sync List expires and is deleted
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed SyncListInstance
 */
/* jshint ignore:end */
SyncListInstance.prototype.update = function update(opts, callback) {
  return this._proxy.update(opts, callback);
};

/* jshint ignore:start */
/**
 * Access the syncListItems
 *
 * @function syncListItems
 * @memberof Twilio.Sync.V1.ServiceContext.SyncListInstance#
 *
 * @returns {Twilio.Sync.V1.ServiceContext.SyncListContext.SyncListItemList}
 */
/* jshint ignore:end */
SyncListInstance.prototype.syncListItems = function syncListItems() {
  return this._proxy.syncListItems;
};

/* jshint ignore:start */
/**
 * Access the syncListPermissions
 *
 * @function syncListPermissions
 * @memberof Twilio.Sync.V1.ServiceContext.SyncListInstance#
 *
 * @returns {Twilio.Sync.V1.ServiceContext.SyncListContext.SyncListPermissionList}
 */
/* jshint ignore:end */
SyncListInstance.prototype.syncListPermissions = function syncListPermissions()
    {
  return this._proxy.syncListPermissions;
};

/* jshint ignore:start */
/**
 * Provide a user-friendly representation
 *
 * @function toJSON
 * @memberof Twilio.Sync.V1.ServiceContext.SyncListInstance#
 *
 * @returns Object
 */
/* jshint ignore:end */
SyncListInstance.prototype.toJSON = function toJSON() {
  let clone = {};
  _.forOwn(this, function(value, key) {
    if (!_.startsWith(key, '_') && ! _.isFunction(value)) {
      clone[key] = value;
    }
  });
  return clone;
};

SyncListInstance.prototype[util.inspect.custom] = function inspect(depth,
    options) {
  return util.inspect(this.toJSON(), options);
};


/* jshint ignore:start */
/**
 * Initialize the SyncListContext
 *
 * @constructor Twilio.Sync.V1.ServiceContext.SyncListContext
 *
 * @property {Twilio.Sync.V1.ServiceContext.SyncListContext.SyncListItemList} syncListItems -
 *          syncListItems resource
 * @property {Twilio.Sync.V1.ServiceContext.SyncListContext.SyncListPermissionList} syncListPermissions -
 *          syncListPermissions resource
 *
 * @param {V1} version - Version of the resource
 * @param {sid_like} serviceSid -
 *          The SID of the Sync Service with the Sync List resource to fetch
 * @param {sid_like} sid - The SID of the Sync List resource to fetch
 */
/* jshint ignore:end */
SyncListContext = function SyncListContext(version, serviceSid, sid) {
  this._version = version;

  // Path Solution
  this._solution = {serviceSid: serviceSid, sid: sid, };
  this._uri = `/Services/${serviceSid}/Lists/${sid}`;

  // Dependents
  this._syncListItems = undefined;
  this._syncListPermissions = undefined;
};

/* jshint ignore:start */
/**
 * fetch a SyncListInstance
 *
 * @function fetch
 * @memberof Twilio.Sync.V1.ServiceContext.SyncListContext#
 *
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed SyncListInstance
 */
/* jshint ignore:end */
SyncListContext.prototype.fetch = function fetch(callback) {
  var deferred = Q.defer();
  var promise = this._version.fetch({uri: this._uri, method: 'GET'});

  promise = promise.then(function(payload) {
    deferred.resolve(new SyncListInstance(
      this._version,
      payload,
      this._solution.serviceSid,
      this._solution.sid
    ));
  }.bind(this));

  promise.catch(function(error) {
    deferred.reject(error);
  });

  if (_.isFunction(callback)) {
    deferred.promise.nodeify(callback);
  }

  return deferred.promise;
};

/* jshint ignore:start */
/**
 * remove a SyncListInstance
 *
 * @function remove
 * @memberof Twilio.Sync.V1.ServiceContext.SyncListContext#
 *
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed SyncListInstance
 */
/* jshint ignore:end */
SyncListContext.prototype.remove = function remove(callback) {
  var deferred = Q.defer();
  var promise = this._version.remove({uri: this._uri, method: 'DELETE'});

  promise = promise.then(function(payload) {
    deferred.resolve(payload);
  }.bind(this));

  promise.catch(function(error) {
    deferred.reject(error);
  });

  if (_.isFunction(callback)) {
    deferred.promise.nodeify(callback);
  }

  return deferred.promise;
};

/* jshint ignore:start */
/**
 * update a SyncListInstance
 *
 * @function update
 * @memberof Twilio.Sync.V1.ServiceContext.SyncListContext#
 *
 * @param {object} [opts] - Options for request
 * @param {number} [opts.ttl] - An alias for collection_ttl
 * @param {number} [opts.collectionTtl] -
 *          How long, in seconds, before the Sync List expires and is deleted
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed SyncListInstance
 */
/* jshint ignore:end */
SyncListContext.prototype.update = function update(opts, callback) {
  if (_.isFunction(opts)) {
    callback = opts;
    opts = {};
  }
  opts = opts || {};

  var deferred = Q.defer();
  var data = values.of({'Ttl': _.get(opts, 'ttl'), 'CollectionTtl': _.get(opts, 'collectionTtl')});

  var promise = this._version.update({uri: this._uri, method: 'POST', data: data});

  promise = promise.then(function(payload) {
    deferred.resolve(new SyncListInstance(
      this._version,
      payload,
      this._solution.serviceSid,
      this._solution.sid
    ));
  }.bind(this));

  promise.catch(function(error) {
    deferred.reject(error);
  });

  if (_.isFunction(callback)) {
    deferred.promise.nodeify(callback);
  }

  return deferred.promise;
};

Object.defineProperty(SyncListContext.prototype,
  'syncListItems', {
    get: function() {
      if (!this._syncListItems) {
        this._syncListItems = new SyncListItemList(
          this._version,
          this._solution.serviceSid,
          this._solution.sid
        );
      }
      return this._syncListItems;
    }
});

Object.defineProperty(SyncListContext.prototype,
  'syncListPermissions', {
    get: function() {
      if (!this._syncListPermissions) {
        this._syncListPermissions = new SyncListPermissionList(
          this._version,
          this._solution.serviceSid,
          this._solution.sid
        );
      }
      return this._syncListPermissions;
    }
});

/* jshint ignore:start */
/**
 * Provide a user-friendly representation
 *
 * @function toJSON
 * @memberof Twilio.Sync.V1.ServiceContext.SyncListContext#
 *
 * @returns Object
 */
/* jshint ignore:end */
SyncListContext.prototype.toJSON = function toJSON() {
  return this._solution;
};

SyncListContext.prototype[util.inspect.custom] = function inspect(depth,
    options) {
  return util.inspect(this.toJSON(), options);
};

module.exports = {
  SyncListList: SyncListList,
  SyncListPage: SyncListPage,
  SyncListInstance: SyncListInstance,
  SyncListContext: SyncListContext
};
